import { HttpClient, HttpHeaders } from "@angular/common/http";
export class Constants {
  public static OBJSAVEDATA = "OBJSAVEDATA";
  public static PROJECT_TITLE = " | La-oficina";
  public static PAGE_LOGIN_TITLE = "Login" + Constants.PROJECT_TITLE;
  public static PAGE_FORGET_PASSWORD_TITLE =
    "Forgot Password" + Constants.PROJECT_TITLE;
  public static PAGE_CHANGE_PASSWORD_TITLE =
    "Change Password" + Constants.PROJECT_TITLE;
  public static PAGE_EDIT_PROFILE_TITLE =
    "Edit Profile" + Constants.PROJECT_TITLE;
  public static PAGE_TITLE = "";
  public static SESSION_NAME = "la-oficina";
  public static SAVED_DATA = "savedData";
  public static CONST_EN = "en";
  public static SEVERITY_ERROR = "error";
  public static SEVERITY_SUCCESS = "success";
  public static LANG_CODE_EN = "en";
  public static STATUS_CODE_0 = 0;
  public static STATUS_CODE_1 = 1;
  public static STATUS_CODE_2 = 2;
  public static STATUS_CODE_3 = 4;
  public static STATUS_CODE_4 = 4;
  public static STATUS_CODE_5 = 5;
  public static STATUS_CODE_6 = 6;
  public static STATUS_CODE_7 = 7;
  public static STATUS_CODE_8 = 8;

  public static RESPONSE_CODES: any = {
    SUCCESS_CODE: 200,
    SERVER_ERROR_CODE: 500,
    UNAUTHORIZED_ERROR_CODE: 401,
    NOT_FOUND_ERROR_CODE: 404,
    BAD_REQUEST_ERROR_CODE: 400,
    UNKNOWN_ERROR_CODE: 0,
  };
  public static ROWS_PER_PAGE_OPTIONS = [5, 10, 15];
  public static ROWS = 5;

  /* LOGIN PRAMETER KEYS */
  public static LOGIN_PRAMETER: any = {
    KEY_API_EMAIL: "username",
    KEY_API_PASSWORD: "password",
  };
}
